{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "PageBanner",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "showBreadcrumb"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "backgroundMediaId": {
      "title": "Background image",
      "type": [
        "string",
        "null"
      ],
      "pattern": "^[0-9a-fA-F-]{36}$",
      "x-ui": "media"
    },
    "showBreadcrumb": {
      "title": "Show breadcrumb",
      "type": "boolean",
      "x-ui": "switch"
    }
  }
}
